export default class IddleState {
	constructor(scene, stateMachine) {
		this.stateMachine = stateMachine;
		this.stateObject = scene;
		this.slotControls = scene.slotControls;
		this.spinButton = this.slotControls.slotSpinButton;
		this.autoSpinButton = this.slotControls.slotAutoSpinButton;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - enter from: ' + (oldState === null ? 'null' : oldState.toString()));
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.add(this.longPressSpin_Click, this);
			this.spinButton.clickEvent.add(this.spin_Click, this);
			this.spinButton.pointerDownEvent.add(this.spin_PointerDown, this);
			this.spinButton.longPointerDownEvent.add(this.spin_LongPointerDown, this);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.add(this.autoSpin_Click, this);
		}

		this.slotControls.setControlActivity(true, true, true); // activity, spinButtonAcivity, autoSpinButtonAcivity
		this.slotControls.setSpinButtonText('SPIN');
	}

	exitTo(newState) {
		console.log(this.toString() + ' - Exit To: ' + newState.toString());
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.remove(this.longPressSpin_Click);
			this.spinButton.clickEvent.remove(this.spin_Click);
			this.spinButton.pointerDownEvent.remove(this.spin_PointerDown);
			this.spinButton.longPointerDownEvent.remove(this.spin_LongPointerDown);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.remove(this.autoSpin_Click);
		}
	}

	//region input
	spin_PointerDown() {}

	spin_LongPointerDown() {}

	longPressSpin_Click() {
		if (this.slotControls.holdToAutoSpin) {
			this.slotControls.setAutoSpinsMode();
		}
		this.stateMachine.changeState(this.stateObject.preSpinState);
	}

	spin_Click() {
		console.log(this.toString() + ' - Spin Click');
		this.stateMachine.changeState(this.stateObject.preSpinState);
	}

	autoSpin_Click() {
		console.log(this.toString() + ' - Auto Spin Click');
		this.slotControls.setAutoSpinsMode();
		this.stateMachine.changeState(this.stateObject.preSpinState);
	}
	//endregion input

	//region old
	handleInput() {}

	physicsUpdate() {}
	//endregion old

	toString() {
		return 'IddleState';
	}
}
